import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {GlobalService} from 'app/global/global.service';
import {contractTypes} from 'app/main/pages/contract-control/constants/constants';
import {ContractControlService} from 'app/main/pages/contract-control/contract-control.service';
import {ContractType} from 'app/main/pages/users/groups/interfaces';
import {delay, of, Subscription, take} from 'rxjs';
import {IConnectedContracts} from '../../../../contacts/organizations/organizations.dto';
import {DocumentListingFacade} from '../../../store/document-listing.facade';
import {AddToContractControlFormHelper} from '../add-to-contract-control-modal.component';
import {IAutoFillUploadFile} from '../create-cc-by-ai-form/ai-cc-import.service';
import {IaiProcessedData} from '../iai-processed-data.interface';

@Component({
  selector: 'app-final-step',
  templateUrl: './final-step.component.html',
  styleUrl: './final-step.component.scss'
})
export class FinalStepComponent implements OnInit, IaiProcessedData{
  @Input() mainFormGroup: FormGroup;
  @Input() aiProcessedData: IAutoFillUploadFile;
  @ViewChild('contract_no', {static: false}) contract_no: ElementRef;

  public contractTypes: ContractType[] = contractTypes;
  public loading: boolean = false;
  public searchedContracts:IConnectedContracts[] = [];
  public keyword: string = 'contract_control_name';
  public contractData$ = this.documentFacade$.contractData$;
  public editableInput = {contract_no: false}
  public elementSubscription: Subscription;

  constructor (
    private contractControlService: ContractControlService,
    private globalService: GlobalService,
    private documentFacade$: DocumentListingFacade,
    private transloco: TranslocoService,
    private _addToContractControlFormHelper:AddToContractControlFormHelper 
  ) {}

  
    ngOnInit(): void {
      if(this.aiProcessedData) {
          this.initializeWithAIProcessedData(this.aiProcessedData);
      }
    }
    initializeWithAIProcessedData(aiProcessedData: IAutoFillUploadFile): void {
      const contractNoFormControl = this.mainFormGroup
      ?.get('contractForm')
      ?.get('contract_no');

      const aiCoNumber =  this._addToContractControlFormHelper.getAIValueIfNotModifedByUser(contractNoFormControl, aiProcessedData.contract_no);
      const formValue = contractNoFormControl?.value;

      if (aiCoNumber !="" && formValue ==="" && aiCoNumber != formValue){
        // update the Contract number only if has ai data different them current value and form was not touched by user
        this.updateContractNumber(aiCoNumber as string);
      }
     
    }

  updateContractStatus(column: string, value: string){
    const isContractActive = this.mainFormGroup.get('periodRenewalForm')?.get('is_contract_active')?.value;
    const startDateNotDefined = this.mainFormGroup.get('periodRenewalForm')?.get('start_date')?.value !=null;
    const autoRenewNotSet = this.mainFormGroup.get('periodRenewalForm')?.get('auto_renew')?.value !=null;

    if(isContractActive == 0 && (startDateNotDefined || autoRenewNotSet)){
      this.globalService.toastrError(this.transloco.translate('Change status validation message (Add contract card, final step) - You have to set period and renewal start date'));
      return;
    }
    this.mainFormGroup.get('contractForm').get(column)?.setValue(value);
    this.mainFormGroup.get('contractForm').get(column).markAsDirty();
    this.mainFormGroup.get('contractForm').get(column).markAsTouched();
    this.documentFacade$.updateContractFirstForm(column, value);
  }



  updateContractType(column: string, value: string){
    if(this.mainFormGroup.get('contractForm').get(column)?.value == value) return;
    this.mainFormGroup.get('contractForm').get(column)?.setValue(value);
    this.documentFacade$.updateContractFirstForm(column, value);
    // @ts-expect-error TODO: type
    this.setContracts([])
  }



  unlinkContract($id: number){
    this.contractData$.pipe(take(1)).subscribe((response) => {
      const connectedContracts = (response)?.connected_contracts || [];
      const filteredContracts = connectedContracts.filter(x => x.id !== $id);
        //@ts-expect-error type
      this.setContracts(filteredContracts);
    });
  }


  get ContractType(){
    return this.mainFormGroup.get('contractForm')?.get('contract_type')?.value;
  }



  toggleInput(key: string) {
    this.editableInput[key] = !this.editableInput[key];
    this.elementSubscription = of(null).pipe(
      take(1),
      delay(0)
    ).subscribe(() => {
      this.contract_no ? this.contract_no.nativeElement.focus() : null;
    });
  }

  updateContractNumberOnBlur(contractNumber: string){
    this.updateContractNumber(contractNumber);
    const formControl = this.mainFormGroup
      ?.get('contractForm')
      ?.get('contract_no')
    
      formControl?.markAsDirty()
      formControl?.markAsTouched();
  }

  updateContractNumber(contractNumber: string){
    this.mainFormGroup.get('contractForm')?.patchValue({contract_no: contractNumber})
    this.documentFacade$.updateContractFirstForm('contract_no', contractNumber);
    this.editableInput['contract_no'] = false
  }
  
  /**
   * Get contract
   * @param q 
   */
  searhContracts(q: string = '') {
    this.loading = true;
    const type = this.ContractType == 1 ? 2 : 1;

    this.contractControlService.searchContracts(q, type).subscribe({
      next: async (contracts) => {
        this.searchedContracts = contracts ?? [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }


  selectContract($item) {
    this.contractData$.pipe(take(1)).subscribe((response) => {
        const connectedContracts = response?.connected_contracts || [];
        const exists = connectedContracts.some(x => x.id === $item.id);
        if (exists) {
            this.globalService.toastrError(`${$item?.contract_control_name} is Already Connected`);
        } else {
            this.addContract($item, connectedContracts);
        }
    });
  }


  private addContract($item, connectedContracts) { //TODO add type when contract contract will be covered by types
    const contracts = [];
    console.log(this.ContractType, 'contract type')
    if(this.ContractType == 1){
      connectedContracts = [...connectedContracts, { id: $item.id, contract_control_name: $item.contract_control_name }];
      console.log(connectedContracts, 'connectedContracts')
      this.setContracts(connectedContracts);
    } else {
      contracts.push({ id: $item.id, contract_control_name: $item.contract_control_name });
      //TODO: type mismash verify
      //@ts-expect-error type mismash verify
      this.setContracts(contracts);
    }
    this.searchedContracts = [];
  }


  private setContracts(connectedContracts: number | string){
    this.documentFacade$.setDocumentData('connected_contracts', connectedContracts);
  }
}
